var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 133,
    viewBox: "0 0 411 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1251 102.08C27.3248 102.08 18.8285 98.7319 12.6364 92.0357C6.51619 85.2675 3.4561 76.1953 3.4561 64.819C3.4561 53.4426 6.51619 44.4064 12.6364 37.7102C18.8285 30.942 27.3248 27.5579 38.1251 27.5579C48.7094 27.5579 56.8456 30.15 62.5338 35.3341C68.222 40.5183 71.0661 47.6465 71.0661 56.7187V57.6907H53.7856V57.1507C53.7856 51.9666 52.5975 48.3665 50.2215 46.3504C47.8454 44.2624 43.7773 43.2183 38.0171 43.2183C31.6809 43.2183 27.2168 44.7304 24.6247 47.7545C22.0326 50.7785 20.7366 56.4667 20.7366 64.819C20.7366 73.1712 22.0326 78.8594 24.6247 81.8834C27.2168 84.9075 31.6809 86.4196 38.0171 86.4196C43.7773 86.4196 47.8454 85.4116 50.2215 83.3955C52.5975 81.3074 53.7856 77.6713 53.7856 72.4872V71.9472H71.0661V72.9192C71.0661 81.9915 68.222 89.1197 62.5338 94.3038C56.8456 99.488 48.7094 102.08 38.1251 102.08Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 66.5002C81 45.6055 97.9385 28.667 118.833 28.667C139.728 28.667 156.667 45.6055 156.667 66.5002C156.667 87.395 139.728 104.333 118.833 104.333C97.9385 104.333 81 87.395 81 66.5002Z",
    fill: "#7F30FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.391 101H167.743V28.6379H195.391C207.056 28.6379 216.2 31.842 222.824 38.2502C229.52 44.6584 232.869 53.5146 232.869 64.819C232.869 76.1233 229.52 84.9795 222.824 91.3877C216.2 97.7959 207.056 101 195.391 101ZM195.175 43.2183H183.943V86.4196H195.175C202.736 86.4196 207.992 84.9075 210.944 81.8834C213.968 78.8594 215.48 73.1712 215.48 64.819C215.48 56.4667 213.968 50.7785 210.944 47.7545C207.992 44.7304 202.736 43.2183 195.175 43.2183ZM295.391 101H240.202V28.6379H295.391V43.2183H256.402V57.3667H293.771V71.8392H256.402V86.4196H295.391V101Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 328.866,
    y: 40.4004,
    width: 20.2,
    height: 20.2,
    fill: "#FF007A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 308.666,
    y: 60.6006,
    width: 20.2,
    height: 20.2,
    fill: "#FF007A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 349.571,
    y: 60.6006,
    width: 20.2,
    height: 20.2,
    fill: "#FF007A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 328.866,
    y: 80.8008,
    width: 20.2,
    height: 20.2,
    fill: "#FF007A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 369.771,
    width: 20.2,
    height: 20.2,
    fill: "#7F30FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 349.571,
    y: 20.2002,
    width: 20.2,
    height: 20.2,
    fill: "#7F30FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 390.476,
    y: 20.2002,
    width: 20.2,
    height: 20.2,
    fill: "#7F30FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 369.771,
    y: 40.4004,
    width: 20.2,
    height: 20.2,
    fill: "#7F30FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.0c9a01f28b3b2810f92f7e5a3b7eda7a.svg";
export { ForwardRef as ReactComponent };